import { type ReactNode } from 'react';
import { Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/use-auth';
import { Container } from './container';

interface ProtectedRouteProps {
  adminRequired: boolean;
  children: ReactNode;
}

export const ProtectedRoute = ({ children, adminRequired }: ProtectedRouteProps) => {
  const { t } = useTranslation();
  const { authenticated, hasBrokerPanelRole, keycloakLogin } = useAuth();

  if (!authenticated) {
    return (
      <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          {t('auth.loginRequired')}
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {t('auth.loginPageDescription')}
        </Typography>
        <Button variant="contained" color="primary" onClick={keycloakLogin}>
          {t('auth.login')}
        </Button>
      </Container>
    );
  }

  if (adminRequired && !hasBrokerPanelRole) {
    return (
      <Container maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          {t('auth.accessDenied')}
        </Typography>
        <Typography variant="body1">{t('auth.accessDeniedDescription')}</Typography>
      </Container>
    );
  }

  return <>{children}</>;
};
